import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@shared/constants/routes';

export function ForbiddenPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('app');
  return (
    <Result
      status="403"
      title={t('forbidden.title')}
      subTitle={t('forbidden.subTitle')}
      extra={
        <Button
          type="primary"
          onClick={() => {
            void navigate(ROUTES.DASHBOARD);
          }}
        >
          {t('forbidden.backToDashboard')}
        </Button>
      }
    />
  );
}

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('app');
  return (
    <Result
      status="404"
      title={t('notFound.title')}
      subTitle={t('notFound.subTitle')}
      extra={
        <Button
          type="primary"
          onClick={() => {
            void navigate(ROUTES.DASHBOARD);
          }}
        >
          {t('notFound.backToDashboard')}
        </Button>
      }
    />
  );
}
